import React, { ReactElement } from 'react';

import { CommonPlayer } from 'components/Media/Common';

import { ComponentMediaProps } from '../types';

export const Audio = (props: ComponentMediaProps): ReactElement => {
  return <CommonPlayer {...props} />;
};
